import React from 'react';
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({

  dndFormControlLabel: {
    transform: 'none',
    position: 'relative',
    marginBottom: theme.spacing(1)
  },
  autoCompleteCardContainer: {
    overflow: 'visible !important'
  },
  dndFormControlLabelPrimary: {
    transform: 'none',
    position: 'relative',
    marginBottom: theme.spacing(1),
    fontWeight: '500',
    color:theme?.agentTheme?.card?.muted_foreground
  },
  greyText: {
    color: theme?.agentTheme?.text?.body_text_color
  },
  marginLabel: {
    marginBottom: theme.spacing(1),
    fontWeight: 500,
  },
  error:{
    color:theme.agentTheme.destructive.main
  },
  themedLabel:{
    color:theme.agentTheme.background.foreground
  }

}))